import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import './AdminForm.css';
import privateAxios from '../../utils/axios/privateAxios';
import moment from 'moment';

const AdminForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await privateAxios.get(`/private/admin-form/${id}`);
        setForm(response.data.form);
      } catch (error) {
        console.error('Error fetching form', error);
      } finally {
        setLoading(false);
      }
    };

    fetchForm();
  }, [id]);

  if (loading) return <div className="admin-form-loading">Loading...</div>;

  if (!form) return <div className="admin-form-error">Form not found.</div>;

  return (
    <div className="admin-form">
      <div className="admin-form-header">
        <h1>{form.title}</h1>
        <p className="admin-form-meta">
          By: {form.createdBy?.firstname} {form.createdBy?.lastname} | Created: {moment(form.createdAt).format('MMMM DD, YYYY')}
          {form.updatedAt && ` | Last Edited: ${moment(form.updatedAt).format('MMMM DD, YYYY')}`}
        </p>
      </div>

      {form.imageUrl && (
        <div className="admin-form-image-wrapper">
          <img src={form.imageUrl} alt="Form" />
        </div>
      )}

      <div
        className="admin-form-content"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(form.description) }}
      ></div>

      <div className="admin-form-actions">
        <button onClick={() => navigate(`/admin-edit-form/${id}`)}>Edit Form</button>
        <button onClick={() => navigate('/admin-forms')}>Back to Forms</button>
      </div>
    </div>
  );
};

export default AdminForm;